/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import * as Actions from './actions';
import CBANDPLANS from '../../assets/cq/cbandPlans.json';
// import WILLOWPLANS from '../../assets/cq/willowPlans.json';
import * as Constants from './Constants';
import { resetAPIStatus, apiRequestCompleted } from '../../components/common/Loader/action';
// import { logError, FE_API_ERROR, FE_API_JS_ERROR } from '../../services/loggerService';
import {
  getSession,
  getServiceUrlandE2eRequestId,
  GetProcessStepPages,
  GetCurrentPageName,
  enablePegaProcessSteps,
} from '../../components/common/Helpers/index';
import { apiUrls } from '../../constants/apiUrl';
// import { logError, FE_API_ERROR, FE_API_JS_ERROR } from '../../services/loggerService';
// import * as notificationActions from '../../components/common/NotificationBar/actions';
import logger from '../../components/common/ErrorBoundary/logger_new';
import { PRELOAD_DATA_API } from '../../constants/asyncRequestMap';
import { checkInvalidCaseCartError } from '../../components/common/Helpers/commonLog';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';
import { getErrorLogObj } from '../../services/loggerService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { eventDispatcher } from '../../components/common/Tagging/index';

function* getCBandPlans({ data }) {
  let cBandError = false;
  yield put({ type: Constants.ERR_OCCURED, response: cBandError });
  yield put({ type: Constants.CEF_PLANS_ERROR, response: cBandError, errorMessage: null });
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  /** --END-- */

  yield put(resetAPIStatus(PRELOAD_DATA_API.GET_AVAILABLEPLANS));
  let serviceDetails = null;
  try {
    const apiResponse = yield call(Actions.getPlansCBand, data);
    yield put(apiRequestCompleted(PRELOAD_DATA_API.GET_AVAILABLEPLANS));
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: 'C_BAND_PLANS_SUCCESS', response: apiResponse.data });
      yield put({ type: 'API_LOADED', response: true });
      yield put(
        Actions.updateACPModalALStatus(
          !!(apiResponse?.data?.output?.acpInfo?.nladSubscriberId && apiResponse?.data?.output?.acpInfo?.nladSubscriberId !== 'null'),
        ),
      );
      yield put(
        Actions.updateVFModalALStatus(!!(apiResponse?.data?.output?.acpInfo?.benefit && apiResponse?.data?.output?.acpInfo?.benefit === 'VFWD')),
      );
      if (apiResponse?.data?.output?.acpInfo?.benefit && apiResponse?.data?.output?.acpInfo?.benefit === 'VFWD') {
        eventDispatcher('sendData', {
          name: '',
          svars: {
            evar64: 'VFWD',
          },
        });
      }
      if (apiResponse?.data?.output?.acpInfo?.nladSubscriberId && apiResponse?.data?.output?.acpInfo?.nladSubscriberId !== 'null') {
        eventDispatcher('sendData', {
          name: '',
          svars: {
            evar64: 'ACP',
          },
        });
      }
      if (apiResponse?.data?.output?.plans === null || apiResponse?.data?.output?.plans === undefined || isEmpty(apiResponse?.data?.output?.plans)) {
        const errorLog = {
          json: true,
          eventType: 'BLOCKER',
          message: 'GENERIC_ERROR_PAGE',
          note: 'from Plan component',
          // networkError: {
          //   error: apiResponse,
          //   response: apiResponse.data.errors || null,
          // },
        };
        logger(errorLog);
      }

      hideLoader();
    } else {
      // logError('getCBandPlans', apiResponse.data.errors, FE_API_ERROR);
      if (apiResponse && apiResponse.data && apiResponse.data.errors) {
        cBandError = true;
        serviceDetails = getServiceUrlandE2eRequestId('getCBandPlanDetails', apiResponse);
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getCBandPlans ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);

        if (apiResponse.data.errors.id && apiResponse.data.errors.id === '701') {
          window.location.href = apiUrls().redirect5Ghome;
        }
        hideLoader();
        /** --END-- */
      }
      yield put({ type: Constants.ERR_OCCURED, response: cBandError, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PLANS_ERROR, response: cBandError, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
    }
  } catch (error) {
    // logError('getCBandPlans', error, FE_API_JS_ERROR);
    yield put(apiRequestCompleted(PRELOAD_DATA_API.GET_AVAILABLEPLANS));
    if (error) {
      cBandError = true;
      serviceDetails = {
        method: 'getCBandPlans',
      };
      yield put({ type: Constants.ERR_OCCURED, response: cBandError, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PLANS_ERROR, response: cBandError, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (error) {
      hideLoader();
      /** --END-- */
    }
  }
  // yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

export function* getBannerPlans({ data }) {
  yield put({ type: Constants.ASYNC_FETCH });
  const apiResponse = yield call(Actions.getBannerAPI, data);

  try {
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.BANNER_PROMOTION_FLOW_VALUE, response: apiResponse.data, error: false });
      const paylod = {
        eventType: 'INFO',
        message: `LocalOffer = ${apiResponse.data.serviceResponse?.mtnInfo?.[0]?.propositionList?.proposition?.[0]?.isLocalOffer}`,
        note: 'Local Offer applied',
      };
      logger(paylod);
    } else if (apiResponse?.data?.errors) {
      if (apiResponse.data.loggerData) {
        apiResponse.data.loggerData.note = `localOffer ${apiResponse?.data?.loggerData.note}`;
      }
      logger(apiResponse?.data?.loggerData);
    }
  } catch (error) {
    if (error) {
      const errorLog = getErrorLogObj({
        note: 'from cbands plan local banner sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().localOfferBanner}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errorLog);
    }
    yield put({ type: Constants.BANNER_PROMOTION_FLOW_VALUE, response: {}, error: true });
  }
}

function* getPlanInformationDetails() {
  try {
    const apiResponse = yield call(Actions.getPlanInformationDetails);
    if (apiResponse && apiResponse?.data && apiResponse.status === 200) {
      hideLoader();
      yield put({
        type: 'PLAN_INFORMATION_SUCCESS',
        response: apiResponse?.data,
      });
    }
    hideLoader();
  } catch (error) {
    console.log(error);
  }
}

// getCBandPlanDetails

function* getCBandPlanDetails({ data }) {
  let cBandError = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, response: cBandError });
  yield put({ type: Constants.CEF_PLANS_ERROR, response: cBandError, errorMessage: null });
  yield put({ type: Constants.ASYNC_FETCH });
  // showLoader();
  /** --END-- */
  const cbandPlans = CBANDPLANS;
  // const willowPlans = WILLOWPLANS;
  try {
    const apiResponse = yield call(Actions.getPlansCBandDetails, data);
    const apiPlansResponse = apiResponse && apiResponse.data && !apiResponse.data.errors && apiResponse.data.willowOverview;
    if (apiPlansResponse) {
      yield put({ type: 'C_BAND_PLANS_DETAILS_SUCCESS', response: apiResponse.data });

      // hideLoader();
    } else {
      if ((apiResponse && apiResponse.data && apiResponse.data.errors) || apiResponse?.data?.serviceHeader?.statusCode !== '00') {
        cBandError = true;
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getCBandPlanDetails ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);

        serviceDetails = getServiceUrlandE2eRequestId('getCBandPlanDetails', apiResponse);
        // hideLoader();
      }
      yield put({ type: Constants.ERR_OCCURED, response: cBandError, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PLANS_ERROR, response: cBandError, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
    }
  } catch (error) {
    if (error) {
      cBandError = true;
      serviceDetails = {
        method: 'getCBandPlanDetails',
      };
      yield put({ type: Constants.ERR_OCCURED, response: cBandError, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PLANS_ERROR, response: cBandError, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (getSession('LocalFlow') && getSession('LocalFlow') === 'Y') {
      yield put({ type: 'C_BAND_PLANS_DETAILS_SUCCESS', response: cbandPlans });
      // logError('getCBandPlanDetails', error, FE_API_JS_ERROR);
    } else {
      // logError('getPlans', error, FE_API_JS_ERROR);
      // hideLoader();
    }
  }
  // yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* selectedPlanCBand({ data }) {
  let cBandError = false;
  let invalidCaseError = false;
  let serviceDetails = null;
  yield put({ type: Constants.ERR_OCCURED, response: cBandError });
  yield put({ type: Constants.INVALID_CASE_ERROR, response: invalidCaseError });
  yield put({ type: Constants.CEF_PLANS_ERROR, response: cBandError, errorMessage: null });
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    // const apiResponse = yield call(Actions.selectedPlanAPI, data);
    const LQResponse = getSession('LQResponse');
    const cartId = getSession('cartExist');
    const emailFlow = getSession('emailFlow');
    let apiResponse;
    if ((emailFlow === 'Y' && cartId) || (emailFlow !== 'Y' && LQResponse && cartId)) {
      apiResponse = yield call(Actions.selectedPlanAPI, data);
    } else if (LQResponse && (cartId === '' || cartId === null || cartId === undefined)) {
      window.location.href = apiUrls().expressCartUrl;
    } else {
      window.location.href = apiUrls().redirect5Ghome;
    }
    yield put({ type: Constants.PLAN_SELECTED, response: data });
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      if (enablePegaProcessSteps()) {
        const processStep = GetProcessStepPages(apiResponse?.data?.serviceBody?.serviceResponse?.context?.contextInfo?.processStep);
        if (processStep && processStep !== '') {
          yield put({ type: 'NEXT_PROCESS_STEP', value: processStep });
        }
        const currentPageName = GetCurrentPageName();
        if (currentPageName) {
          yield put({ type: 'PREVIOUS_PROCESS_STEP', value: currentPageName });
        }
      }
      yield put({ type: 'PLAN_SELECTED_SUCCESS', response: apiResponse.data });
      hideLoader();
    } else {
      // logError('selectedPlanCBand', apiResponse.data.errors, FE_API_ERROR);

      if (apiResponse && apiResponse?.status === 400 && apiResponse.data && apiResponse.data.errors) {
        if (checkInvalidCaseCartError(apiResponse.data.errors)) {
          invalidCaseError = true;
          yield put({ type: Constants.CEF_PLANS_ERROR, response: invalidCaseError, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
        }
      } else if (apiResponse && apiResponse.data && apiResponse.data.errors) {
        cBandError = true;
        yield put({ type: Constants.CEF_PLANS_ERROR, response: cBandError, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      }
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `selectedPlanCBand ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);

      serviceDetails = getServiceUrlandE2eRequestId('selectedPlanCBand', apiResponse);
      hideLoader();
      if (apiResponse && (apiResponse.data === undefined || apiResponse.data === null)) {
        hideLoader();
      }
      yield put({ type: Constants.ERR_OCCURED, response: cBandError, serviceinfo: serviceDetails });
      yield put({ type: Constants.INVALID_CASE_ERROR, response: invalidCaseError, serviceinfo: serviceDetails });
    }
  } catch (error) {
    if (error) {
      cBandError = true;
      serviceDetails = {
        method: 'selectedPlanCBand',
      };
      yield put({ type: Constants.ERR_OCCURED, response: cBandError, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PLANS_ERROR, response: cBandError, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    // logError('selectedPlanCBand', error, FE_API_JS_ERROR);
    if (error) {
      hideLoader();
    }
  }
  // yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* updateCurrentSfoDetails({ data }) {
  if (!data) {
    return;
  }
  if (data && data.length > 0) {
    yield put({ type: Constants.UPDATE_SFO_DATA, response: data });
  }
}

function* getFccLabelDetails({ data }) {
  let serviceDetails = null;
  try {
    const apiResponse = yield call(Actions.getFCCLabelDetailsFromAPI, data);
    const apiPlansResponse = apiResponse && apiResponse.data && !apiResponse.data.errors && apiResponse.data;
    if (apiPlansResponse) {
      yield put({ type: Constants.FCC_LABEL_SUCCESS, response: apiResponse.data });
    } else {
      serviceDetails = {
        method: 'FccLabelContentDetails',
      };
      yield put({ type: Constants.FCC_LABEL_ERROR, response: apiPlansResponse, serviceinfo: serviceDetails });
    }
  } catch (error) {
    if (error) {
      serviceDetails = {
        method: 'FccLabelContentDetails',
      };
      yield put({ type: Constants.FCC_LABEL_ERROR, response: error, serviceinfo: serviceDetails });
    }
  }
}

function* actionWatcher() {
  yield takeLatest('PLANS_API', getCBandPlans);
  yield takeLatest(Constants.BANNER_PROMOTION_FLOW, getBannerPlans);
  yield takeLatest('PLAN_INFORMATION', getPlanInformationDetails);
  // CBAND_FED
  yield takeLatest('CBAND_FED', getCBandPlanDetails);
  yield takeLatest('C_BAND_SELECETD_PLAN', selectedPlanCBand);
  yield takeLatest('UPDATE_SFO', updateCurrentSfoDetails);
  yield takeLatest(Constants.FCC_LABEL, getFccLabelDetails);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
